import { wpApiInstance} from '../api/wp-api';
import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';

import { IUser, IWpUser, IWpUserResponse } from '../models/user.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Calls the api route to get user data from WordPress
 * 
 * @param {string} userId the WordPress user id
 * 
 * @returns IWpUser
 */
const wpGetUserIndividual = async ( userID: string ): Promise<IWpUserResponse> => {
  try {
    apiRetry(wpApiInstance);

    const { data } = await wpApiInstance.get(`admin/users/${userID}`);

    return data;
  } catch (error) {
    handleRouteError(error, 'Error getting user');
    throw(error);
  }
}

/**
 * Calls the api route to get user data from AWS
 * 
 * @param {string} userId the WordPress user id
 * 
 * @returns IUser
 */
const awsGetUserIndividual = async ( userId: string, level: string ): Promise<IUser> => {
  try {
    apiRetry(awsApiInstance);

    const { data } = await awsApiInstance.get(`/user/${userId}`, {
      params: {
        'accessLevel': level
      }
    });

    return data;
  } catch (error) {
    handleRouteError(error, 'Error getting user');
    throw(error);
  }
}

export { wpGetUserIndividual, awsGetUserIndividual };